import { render, staticRenderFns } from "./BeefPolicyTypeForm.vue?vue&type=template&id=18f3d08c"
import script from "./BeefPolicyTypeForm.vue?vue&type=script&lang=js"
export * from "./BeefPolicyTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports